function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var SvgCapturaSolicitud = function SvgCapturaSolicitud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BCF0F6"
    },
    cx: 100.5,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.945,
    y: 35,
    style: {
      fill: "#FFEDEE"
    },
    width: 101.109,
    height: 130
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.945,
    y: 35,
    style: {
      fill: "#D5007F"
    },
    width: 101.109,
    height: 17.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 64.336,
    style: {
      fill: "#9B4B4E"
    },
    width: 78,
    height: 8.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 84.559,
    style: {
      fill: "#9B4B4E"
    },
    width: 78,
    height: 8.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 125.004,
    style: {
      fill: "#9B4B4E"
    },
    width: 78,
    height: 8.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 104.781,
    style: {
      fill: "#9B4B4E"
    },
    width: 78,
    height: 8.667
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M0.5,131.306v49.847c0,2.118,1.729,3.848,3.848,3.848h92.305c2.118,0,3.848-1.729,3.848-3.848 v-49.847c0,0-23.877,7.694-50,7.694S0.5,131.306,0.5,131.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6D6D"
    },
    d: "M96.652,119.771H4.348c-2.118,0-3.848,1.729-3.848,3.848v7.688c0,0,23.877,7.694,50,7.694 s50-7.694,50-7.694v-7.688C100.5,121.5,98.771,119.771,96.652,119.771z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.118,
    y: 145.694,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.229,
    height: 26.924
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.958,
    y: 144.771,
    style: {
      fill: "#494949"
    },
    width: 53.848,
    height: 5.771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.958,
    y: 156.306,
    style: {
      fill: "#494949"
    },
    width: 38.466,
    height: 5.771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.576,
    y: 167.848,
    style: {
      fill: "#494949"
    },
    width: 19.229,
    height: 5.771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.958,
    y: 167.848,
    style: {
      fill: "#494949"
    },
    width: 19.236,
    height: 5.771
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCapturaSolicitud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/capturaSolicitud.3c437d16.svg";
export { ForwardRef as ReactComponent };